import type {PageRouteConfig} from '@router';

import CustomDealDetail from 'modules/Services/PromotionCenter/CustomDeal/Detail/Detail';

export function createPromotionCenterCustomDealDetailRoute(): PageRouteConfig {
  return {
    element: <CustomDealDetail />,
    layout: {
      title: 'جزئیات تخفیف',
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: -1,
      headerDataKey: 'customDealDetail'
    },
    initialHeaderData: {
      customDealDetail: {icon: '', iconTitle: '', action: null, title: '', component: null}
    }
  };
}
